var _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polyline, _polyline2, _polyline3, _path, _polygon1, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoExportMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 302,
    height: 344,
    viewBox: "0 0 302 344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 302,
    height: 344,
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A19F9F",
    points: "113,170 113,119 37,83 37,267"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#689923",
    points: "113,170 37,267 37,338 113,325"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2064A1",
    points: "37,83 113,119 113,6 37,19"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B7B7B7",
    points: "113,119 113,170 133,165"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2EA3FD",
    points: "113,119 133,165 159,158 189,151 189,19 113,6"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#85C130",
    points: "133,165 113,170 113,325 189,338 189,241 159,158"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#B7B7B7",
    points: "159,158 189,241 189,151"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#A19F9F",
    points: "189,151 189,241 264,290 264,59 257,52"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2064A1",
    points: "189,151 257,52 218,14 189,19"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#689923",
    points: "264,290 189,241 189,338 264,325"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FEFEFE",
    strokeWidth: 12.2132,
    points: "37,269 113,172 189,153 264,44"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FEFEFE",
    strokeWidth: 12.2132,
    points: "133,167 113,122 37,85"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#FEFEFE",
    strokeWidth: 12.2132,
    points: "159,161 189,243 264,293"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#332C2B",
    fillRule: "nonzero",
    d: "M43 331l69 -12c1,0 1,0 2,0l75 13 69 -12 0 -250 -18 0c-17,0 -31,-14 -31,-31l0 -17 -19 3c-1,0 -2,0 -3,0l-74 -13 -70 12 0 307zm227 -266l0 260 0 0c0,3 -2,5 -5,6l-75 13c-1,0 -2,0 -2,0l-75 -13 -74 13c-1,0 -1,0 -2,0 -3,0 -6,-3 -6,-6l0 -319 0 0c0,-3 2,-6 5,-6l76 -13c0,0 1,0 2,0l75 13 24 -4 57 56z"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E62129",
    fillRule: "nonzero",
    points: "205,162 205,249 176,249 241,335 302,256 302,249 277,249 277,162"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillRule: "nonzero",
    d: "M210 167l0 82 0 5 -5 0 -19 0 55 73 55 -73 -19 0 -5 0 0 -5 0 -82 -62 0zm-10 77l0 -82 0 -5 5 0 72 0 5 0 0 5 0 82 20 0 0 20 -57 74 -4 6 -4 -6 -65 -86 -7 -8 11 0 24 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M130 66c7,-2 14,-3 21,-3l0 0c18,0 35,7 48,20 12,12 19,30 19,48 0,7 -1,15 -3,22l0 0c-9,29 -30,60 -46,81l0 0c-10,13 -18,22 -18,22 0,0 -55,-61 -66,-110l0 0c-1,-5 -2,-10 -2,-15l0 -1c0,-14 5,-28 13,-39 9,-12 21,-21 34,-25l0 0zm21 40c-5,0 -10,2 -14,4 -4,3 -7,7 -8,11 -2,5 -3,10 -2,14 1,5 3,9 7,13 3,3 7,5 12,6 5,1 10,1 14,-1 4,-2 8,-5 11,-9 2,-4 4,-9 4,-13 0,-7 -3,-13 -7,-18 -5,-4 -11,-7 -17,-7l0 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExportMap);
export default __webpack_public_path__ + "static/media/logo_export_map.03f9faf9b6a2b464e9bddcb7faef12d1.svg";
export { ForwardRef as ReactComponent };